
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { CheckboxModule } from 'primeng/checkbox';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { TreeModule } from 'primeng/tree';
import { FiltersUtil } from '../../../product-list/utils/filters-util';
import { ListboxModule } from 'primeng/listbox';
import { TranslateModule } from '@ngx-translate/core';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { ShopService } from '../../../../shop/service/shop.service';
@Component({
  selector: 'app-filter-product',
  standalone: true,
  imports: [
    FormsModule,
    CheckboxModule,
    InputTextModule,
    MultiSelectModule,
    ScrollPanelModule,
    ButtonModule,
    TreeModule,
    DatePickerModule,
    RadioButtonModule,
    ListboxModule,
    TranslateModule,
    IconFieldModule,
    InputIconModule
  ],
  templateUrl: './filter-product.component.html',
  styleUrl: './filter-product.component.scss',
})
export class FilterProductComponent implements OnInit {
  filters = [];
  values = [];
  since;
  outlined = true;
  selectedCategories = [];
  maxDate = new Date();
  minDate = new Date('01/01/1950');
  today = new Date();
  currentPage = 0;
  hasNext = false;
  shopFilterIndex = 0;
  keyword = "";

  constructor(
    public config: DynamicDialogConfig,
    public ref: DynamicDialogRef,
    private readonly changesDetectorRef: ChangeDetectorRef,
    private readonly shopService: ShopService
  ) {}

  ngOnInit() {
    this.filters = this.config.data.filters;
    const appliedFilters = this.config.data.appliedFilters;
    for (let filter of this.filters) {
      if (filter.type === 'date') {
        this.values[filter.name] = [null, null];
      }
      if (appliedFilters[filter.name]) {
        this.values[filter.name] = appliedFilters[filter.name];
      }
    }
    this.changesDetectorRef.detectChanges();
    this.shopFilterIndex = this.filters.findIndex(filter => filter.type == "list")
    if(this.shopFilterIndex != -1) {
      this.hasNext = this.filters[this.shopFilterIndex].hasNext
    }
  }

  loadShops(keyword: string, page: number) {
    this.shopService.getPaginatedShops(keyword, page).subscribe({
      next: (res) => {
        this.filters[this.shopFilterIndex].values = res['shops']
        this.hasNext = res['hasNext']
      }
    })
  }

  updateDateValues(name) {
    this.values[name] = FiltersUtil.updateDateValues(this.since);
    return this.values[name];
  }

  closeModal() {
    const isOnlyImportDateNulls = (
      this.values &&
      Object.keys(this.values).length === 1 &&
      Object.keys(this.values).includes('importDate') &&
      Array.isArray(this.values['importDate']) &&
      this.values['importDate'].length === 2 &&
      this.values['importDate'][0] === null &&
      this.values['importDate'][1] === null
    );

    if(isOnlyImportDateNulls) {
      this.ref.close();
    } else {
      this.ref.close(this.values);
    }
    
  }

  dateChange(name, date) {
    this.outlined = false;
    if (name === 'start') {
      this.minDate = date;
    } else {
      this.maxDate = date;
    }
  }
  getSelectionMode(filter) {
    return filter.selectionMode ?? 'checkbox';
  }
  nextPage(): void {
    if (this.hasNext) {
      this.currentPage++;
      this.loadShops(this.keyword, this.currentPage);
    }
  }

  previousPage(): void {
    if (this.currentPage > 0) {
      this.currentPage--;
      this.loadShops(this.keyword, this.currentPage);
    }
  }

  onFilter(event: any): void {
    const value = event.target.value;
    this.keyword = value;
    this.currentPage = 0;
    this.loadShops(value, 0)
  }
}
